export default __webpack_public_path__ + "static/media/java.4d8f13d7.svg";